import { cn } from '@/lib/cn';

export interface SkeletonProps {
  className?: string;
  /** Renders N stacked bars, the last one shortened like real wrapped text. */
  lines?: number;
  circle?: boolean;
}

/**
 * Loading placeholder.
 *
 * Skeletons must mirror the layout of what they replace — a card grid loads as
 * skeleton cards in the same grid, so nothing shifts when data lands. A
 * centered spinner standing in for a whole page is a layout jump waiting to
 * happen; keep Spinner for in-button and inline cases.
 */
export function Skeleton({ className, lines, circle = false }: SkeletonProps) {
  if (lines && lines > 1) {
    return (
      <div className="space-y-2" aria-hidden>
        {Array.from({ length: lines }, (_, i) => (
          <div
            key={i}
            className={cn('skeleton h-4', i === lines - 1 && 'w-3/5', className)}
          />
        ))}
      </div>
    );
  }

  return <div aria-hidden className={cn('skeleton', circle ? 'rounded-full' : '', className)} />;
}
